/* eslint-disable @typescript-eslint/unbound-method */
import { createContext, useContext } from "react";
import { NavigateOptions } from "backbone";
import { Router } from "../../../router";
import { IWorkflowState } from "../../workflow";


export class RouterContextType {
    constructor (public router: Router) {
    }

    navigate(page: string, options?: NavigateOptions) {
        this.router.navigate(page, options);
    }

    toWorkflow(isLogout = false, nextPageState: IWorkflowState = {}, skipWorkflow?: boolean) {
        this.router.toWorkflow(isLogout, nextPageState, skipWorkflow);
    }
}

export const RouterContext = createContext<RouterContextType | undefined>(undefined);

export const useRouterContext = (): RouterContextType => {
    const context = useContext(RouterContext);
    if (!context) {
        throw new Error("useContext returned an undefined context for the RouterContext");
    }
    return context;
};